export default {
  setTokenList(state, tokenList) {
    state.tokenList = tokenList;
  },
  setFetchTokenListLoading(state, isFetchTokenListLoading) {
    state.isFetchTokenListLoading = isFetchTokenListLoading;
  },
  setFetchTokenListError(state, fetchTokenListError) {
    state.fetchTokenListError = fetchTokenListError;
  },
  setCreateTokenLoading(state, isCreateTokenLoading) {
    state.isCreateTokenLoading = isCreateTokenLoading;
  },
  setCreateTokenError(state, createTokenError) {
    state.createTokenError = createTokenError;
  },
  setDeleteTokenLoading(state, isDeleteTokenLoading) {
    state.isDeleteTokenLoading = isDeleteTokenLoading;
  },
  setDeleteTokenError(state, deleteTokenError) {
    state.deleteTokenError = deleteTokenError;
  },
  setFlashToken(state, flashToken) {
    state.flashToken = flashToken;
  }
};
